module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/theme-greenery-6-ed1b010b4fc2bcc6c95a58ac72c3e0a5.webp";